export default __webpack_public_path__ + "static/media/slider_image_02-md@1x.15a23700.jpg";